export default {
  listBanks: [],
  bank: {
    numero: '',
    descricao: '',
    ativo: true,
  },
}
